import { type JSX, type ReactNode } from 'react'
import { DataTable as PRDataTable, type DataTableProps as PRDataTableProps } from 'primereact/datatable'

export type DataTableProps<TValue extends any[]> = PRDataTableProps<TValue> & {
  children?: ReactNode
  className?: string
}

export default function DataTable<TValue extends any[]>({
  children,
  className = '',
  ...props
}: DataTableProps<TValue>): JSX.Element {
  return (
    <div className={`bg-white border border-gray-200 rounded-sm overflow-hidden shadow-sm ${className}`}>
      <PRDataTable
        {...props}
        className="w-full"
        rowHover={true}
        removableSort
        pt={{
          root: { className: 'w-full' },
          wrapper: { className: 'w-full overflow-x-auto' },
          table: { className: 'w-full min-w-full border-collapse' },
          thead: { className: 'bg-white' },
          row: { className: 'border-b border-gray-50 transition-colors duration-150' },
          headerRow: { className: 'bg-white' },
          rowgroup: { className: 'bg-white' },
          bodyRow: { className: 'hover:bg-gray-50/50 transition-colors duration-150' },
          headerCell: { className: 'text-[11px] font-semibold tracking-wider text-gray-400 uppercase py-3.5 px-5 bg-white border-b border-gray-100 whitespace-nowrap' },
          bodyCell: { className: 'text-sm text-gray-700 py-3.5 px-5 whitespace-nowrap border-b border-gray-50' },
          tbody: { className: '' },
          emptyMessage: { className: 'p-10 text-center text-gray-400 text-sm' },
          sortIcon: { className: 'text-gray-300 ml-1.5' },
          paginator: { className: 'bg-white border-t border-gray-100 px-5 py-3' },
          paginatorTop: { className: 'bg-white border-b border-gray-100 px-5 py-3' },
          paginatorLeft: { className: 'flex items-center gap-2' },
          paginatorRight: { className: 'flex items-center gap-2' },
          pageLinks: { className: 'flex items-center gap-1' },
          pageLink: { className: 'min-w-[2rem] h-9 flex items-center justify-center rounded-sm text-sm text-gray-500 hover:bg-gray-50 transition-colors' },
          pageLinkActive: { className: 'min-w-[2rem] h-9 flex items-center justify-center rounded-sm text-sm font-semibold text-[#3454cf] bg-[#3454cf]/8' },
          firstPageLink: { className: 'min-w-[2rem] h-9 flex items-center justify-center rounded-sm text-gray-400 hover:bg-gray-50 transition-colors' },
          prevPageLink: { className: 'min-w-[2rem] h-9 flex items-center justify-center rounded-sm text-gray-400 hover:bg-gray-50 transition-colors' },
          nextPageLink: { className: 'min-w-[2rem] h-9 flex items-center justify-center rounded-sm text-gray-400 hover:bg-gray-50 transition-colors' },
          lastPageLink: { className: 'min-w-[2rem] h-9 flex items-center justify-center rounded-sm text-gray-400 hover:bg-gray-50 transition-colors' },
          rowsPerPageDropdown: { className: 'border border-gray-200 rounded-sm text-sm text-gray-500 hover:border-gray-300' },
        } as any}
      >
        {children}
      </PRDataTable>
    </div>
  )
}


